import { DocumentData, QueryDocumentSnapshot } from 'firebase/firestore';
import { JobType } from "@leedpulse-monorepo/enums";

export default class Job {
  private _id: string;
  private _idApiKey: string;
  private _idContact: string;
  private _rescheduled: boolean;
  private _type: JobType;
  private _created: Date;
  private _timestamp: Date;
  private _timestampLock: Date;

  constructor(
    id: string,
    idApiKey: string,
    idContact: string,
    rescheduled: boolean,
    type: JobType,
    created: Date,
    timestamp: Date,
    timestampLock: Date
  ) {
    this._id = id;
    this._idApiKey = idApiKey;
    this._idContact = idContact;
    this._rescheduled = rescheduled || false;
    this._type = type;
    this._created = created;
    this._timestamp = timestamp;
    this._timestampLock = timestampLock;
  }

  get id(): string {
    return this._id;
  }

  get idApiKey(): string {
    return this._idApiKey;
  }

  get idContact(): string {
    return this._idContact;
  }

  get type(): JobType {
    return this._type;
  }

  get rescheduled(): boolean {
    return this._rescheduled;
  }

  get created(): Date {
    return this._created;
  }

  get timestamp(): Date {
    return this._timestamp;
  }

  get timestampLock(): Date {
    return this._timestampLock;
  }

  static fromFirestore(
    data: QueryDocumentSnapshot<DocumentData, DocumentData>
  ): Job {
    const jobData = data.data();
    return new Job(
      data.id,
      jobData.id_api_key,
      jobData.id_contact,
      jobData.rescheduled || false,
      jobData.type as JobType,
      new Date(jobData.created),
      new Date(jobData.timestamp),
      new Date(jobData.timestamp_lock)
    );
  }
}
